import { publicValidateCarrier } from "@babackapp/private-api-client/client/use-public-validate-carrier";
import { useMutation } from "@tanstack/react-query";
import { buildReturnRequestPayload } from "../lib/return-request.lib";
import type { ReturnDraft } from "../types";

export const NO_PHYSICAL_RETURN_CODE = "no-physical-return";

/**
 * Calls POST /public/return-request/validate-carrier with the current draft.
 * The backend returns a carrier code; `"no-physical-return"` means the merchant
 * has configured this return to require no physical shipment.
 */
export function useValidateCarrier() {
  return useMutation({
    mutationFn: (draft: ReturnDraft) =>
      publicValidateCarrier(buildReturnRequestPayload(draft)),
  });
}
